import { render, staticRenderFns } from "./FooterSection.vue?vue&type=template&id=1b93c5ea&scoped=true"
var script = {}
import style0 from "./FooterSection.vue?vue&type=style&index=0&id=1b93c5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b93c5ea",
  null
  
)

export default component.exports